/** 👇 Stock Pick */
const Live = () => import(/* webpackChunkName: "live" */ '../views/Live.vue')
const LiveByCountry = () =>
  import(/* webpackChunkName: "live" */ '../views/LiveByCountry.vue')

const StockPickRoute = [
  {
    path: '/stockpick',
    name: 'stockpick',
    component: Live,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Trading Ideas',
    },
  },
  {
    path: '/stockpick/in',
    name: 'stockpick_in',
    component: LiveByCountry,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Trading Ideas Indonesia Stock',
      backLink: 'stockpick',
    },
  },
  {
    path: '/stockpick/us',
    name: 'stockpick_us',
    component: LiveByCountry,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: true,
      navBarBack: false,
      title: 'Trading Ideas US Stock',
      backLink: 'stockpick',
    },
  },
]

export default StockPickRoute
